import script from "./HowToBecomeCoach.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToBecomeCoach.vue?vue&type=script&setup=true&lang=js"

import "./HowToBecomeCoach.vue?vue&type=style&index=0&id=0a8a792b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8a792b"]])

export default __exports__